module.exports = __webpack_public_path__ + "img/pg.75a67c4f.jpg";